<script setup lang="ts">
import {computed, ref} from "vue";
import Translator from "@/utils/common/Translator.ts";
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import {WidgetProps} from "@/utils/presenters/interfaces.ts";
import WhatsAppIcon from "@/assets/widgetIcons/WhatsAppIcon.vue";
import PhoneCallIcon from "@/assets/widgetIcons/PhoneCallIcon.vue";
import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import ErrorTooltip from "@/components/EditView/ErrorTooltip.vue";
import {QInput} from "quasar";
import {focusAndSelectInput} from "@/utils/common/NamaVueWidget.ts";

const props = defineProps<WidgetProps>();
const fieldId = props.field.id!;
const fieldUtil = new FieldWidgetUtil(props.presenter, props.fieldMetaData);

const mWindow = (window as any);

const tel = fieldUtil.formattedValue();
const whatsLink = computed(() => tel.value ? "https://wa.me/" + tel.value : "");
const callLink = computed(() => tel.value ? "tel:" + tel.value : "");
const input = ref<QInput>()

function focus() {
  focusAndSelectInput(input);
}

function canReceiveFocus() {
  return !fieldUtil.isFieldDisabled(props.forceEnableField);
}

defineExpose({focus, canReceiveFocus})
</script>

<template>
  <WidgetContainer :field="field"
                   :entityType="presenter.entityType" :isSpanned="isSpanned" :isFieldDisabled="fieldUtil.isFieldDisabled(forceEnableField)"
                   :isFieldRequired="fieldUtil.isFieldRequired()" :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
                   :isInsideComposite="isInsideComposite">
    <template v-slot:widget="{ showAsPassword, doNotGoToNextWithEnter }">
      <q-input outlined dense hide-bottom-space
               :id="fieldId" ref="input"
               :readonly="fieldUtil.isFieldDisabled(forceEnableField)"
               :type="showAsPassword ? 'password' : 'tel'"
               autocomplete="off"
               :error="!!props.presenter.fetchFieldErrorMsg(fieldId)"
               class="nama-customize-dense-input nama-focused-input"
               :class="{'nama-field-input-disabled':fieldUtil.isFieldDisabled(forceEnableField),'nama-field-input':!fieldUtil.isFieldDisabled(forceEnableField)}"
               input-class="nama-input-class"
               :model-value="tel" @update:model-value="fieldUtil.onPartialUserInput"
               @focus="fieldUtil.onFocus" @blur="fieldUtil.onBlur"
               @keydown.enter="(e)=>{ if (!doNotGoToNextWithEnter) $emit('navigateToNext',{keyboardEvent:e}) }">
        <template v-slot:append>
          <q-avatar square @click.stop="mWindow.open(callLink,'_blank')" rel="noopener noreferrer"
                    :title="Translator.translateId('phoneCall')"
                    class="nama-avatar-hover tw-cursor-pointer">
            <PhoneCallIcon class="tw-w-[18px] tw-h-[18px] nama-widget-icon-hover nama-widget-icon"/>
          </q-avatar>
          <q-avatar square @click.stop="mWindow.open(whatsLink,'_blank')" rel="noopener noreferrer"
                    :title="Translator.translateId('whatsappMessage')"
                    class="nama-avatar-hover tw-cursor-pointer">
            <WhatsAppIcon class="tw-w-[18px] tw-h-[18px] nama-widget-icon-hover nama-widget-icon"/>
          </q-avatar>
        </template>
        <ErrorTooltip v-if="presenter.fetchFieldErrorMsg(fieldId)" :error-msg="presenter.fetchFieldErrorMsg(fieldId)"/>
      </q-input>
    </template>
  </WidgetContainer>
</template>

<style>

</style>
